'use strict';

JournalService.$inject = ['$q', 'mx.SolutionBuilderAgent.Http', 'mx.shell.Config'];
export default function JournalService($q, http, config) {
	return {
		get: get,
		add: add,
		img: img,
		update: update,
	};

	function get(objectId, allowedInPortal, start, count, objectLinkTemplate) {
		var timeOffset = new Date().getTimezoneOffset();
		let operation = allowedInPortal ? 'api/JournalPortal' : 'api/Journal';

		return http.get(
			operation +
				'?objectId=' +
				objectId +
				'&start=' +
				start +
				'&count=' +
				count +
				'&objectLinkTemplate=' +
				encodeURIComponent(objectLinkTemplate) +
				'&timeOffset=' +
				timeOffset
		);
	}

	function add(info) {
		return http.post('api/Journal/Add', info);
	}

	function update(info) {
		http.post('api/Journal/Update', info);
	}

	function img(photo) {
		if (!photo) {
			return '';
		}

		var baseUrl = '';

		if (config.settings && config.settings.imgHosts && config.settings.imgHosts.default) {
			baseUrl = config.settings.imgHosts.default;
		}
		return baseUrl + photo;
	}
}
